export const TYPE_IRS_DETAIL = {
    CURRENCY: 'CURRENCY',
    PERCENTAGE: 'PERCENTAGE'
}